import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
export default function SkuTable({rows,Month1,Month2,Month3}) {
const columns = [
  { field: "id", headerName: "ID", width: 40, hide: true },
  {
    field: 'rbmcode',
    headerName: 'RBM Code',
    width: 90,
    sortable: false,
    align:'left',
    hide: true 
  },
  {
    field: 'rbmname',
    headerName: 'RBM Name',
    width: 200,
    sortable: false,
    align:'left',
  },
  {
    field: 'brand',
    headerName: 'Brand',
    width: 140,
    sortable: false,
    
  },
  {
    field: 'prodcode',
    headerName: 'Prod Code',
    sortable: false,
    hide: true,
  },
  {
    field: 'proddesc',
    headerName: 'Prod Desc',
    width: 220,
    sortable: false,
  },
  {
    field: 'm1_adjusted_budget_unit',
    headerName: `Adj.Bud U(${Month1})`,
    width: 150,
    sortable: true,

    align:'center',
    renderCell: (params, rowId) => {
      const value=parseFloat(params.row.m1_adjusted_budget_unit).toFixed(0)

      return (
        <p title={params.row.m1_adjusted_budget_unit}  style={{align:"center"}}>
          {value}
        </p>
      );
    },
  },
  {
    field: 'm1_adjusted_budget_value',
    headerName: `Adj.Bud V(${Month1})`,
    width: 150,
    sortable: true,
    align:'center',

  },
  {
    field: 'm2_adjusted_budget_unit',
    headerName:`Adj.Bud U(${Month2})`,
    width: 150,
    sortable: true,
    align:'center',
    renderCell: (params, rowId) => {
      const value=parseFloat(params.row.m2_adjusted_budget_unit).toFixed(0)

      return (
        <p title={params.row.m2_adjusted_budget_unit}  style={{align:"center"}}>
          {value}
        </p>
      );
    },
  },
  {
    field: 'm2_adjusted_budget_value',
    headerName:`Adj.Bud V(${Month2})`,
    width: 150,
    sortable: true,
    align:'center',
  },
  {
    field: 'm3_adjusted_budget_unit',
    headerName:`Adj.Bud U(${Month3})`,
    width: 150,
    sortable: true,
    align:'center',
    renderCell: (params, rowId) => {
      const value=parseFloat(params.row.m3_adjusted_budget_unit).toFixed(0)

      return (
        <p title={params.row.m3_adjusted_budget_unit}  style={{align:"center"}}>
          {value}
        </p>
      );
    },
  },
  {
    field: 'm3_adjusted_budget_value',
    headerName:`Adj.Bud V(${Month3})`,
    width: 150,
    sortable: true,
    align:'center',
  
  },

  
];



  return (
    <div style={{ height: 480, width: '100%' }}>
      <DataGrid
        rows={rows}
        Month1={Month1}
        Month2={Month2}
        Month3={Month3}
        columns={columns}
        pageSize={15}
        rowsPerPageOptions={[15]}
        density='compact'
      />
    </div>
  );
}
